<template slot="actions">
  <div :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }">
    <feather-icon
      icon="Edit3Icon"
      svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
      @click="editRecord"
    />
    <feather-icon
      icon="UserMinusIcon"
      svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer"
      @click="showDialogRetirementProcessing"
    />
    <feather-icon
      icon="Trash2Icon"
      svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
      @click="confirmDeleteRecord"
    />
  </div>
</template>

<script>
export default {
  name: "CellRendererActions",
  methods: {
    editRecord() {
      this.$router
        .push({
          name: "enterprise-management-user-edit",
          params: { userId: this.params.data.user_id }
        })
        .catch(() => {});
    },
    showDialogRetirementProcessing() {
      let userData = {
        id: this.params.data.user_id,
        name: this.params.data.name,
        name_en: this.params.data.name_en,
        pictures: this.params.data.pictures
      };
      this.params.context.componentParent.userDataForRetirementProcessing = userData;
    },
    confirmDeleteRecord() {},
    deleteRecord() {
      this.showDeleteSuccess();
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: "success",
        title: "User Deleted",
        text: "The selected user-management was successfully deleted"
      });
    }
  }
};
</script>
